export const PACKING_LIST_DOCUMENT_TYPE = "Packing list";

export const documentTypes = [
	{ id: "CMR", name: "osfc.fields.document.types.cmr", accept: ".pdf,.jpg,.jpeg,.png,.webp" },
	{
		id: PACKING_LIST_DOCUMENT_TYPE,
		name: "osfc.fields.document.types.packing_list",
		accept: ".pdf,.xls,.xlsx",
	},
	{
		id: "Export documents",
		name: "osfc.fields.document.types.export_documents",
		accept: ".pdf,.doc,.docx",
	},
	{ id: "Email", name: "osfc.fields.document.types.email", accept: ".eml,.msg" },
	{
		id: "Other",
		name: "osfc.fields.document.types.other",
		accept: ".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx,.txt",
	},
	{ id: "Moving report", name: "osfc.fields.document.types.moving_report", accept: ".pdf" },
	{
		id: "Excel list for plukk",
		name: "osfc.fields.document.types.excel_list_for_plukk",
		accept: ".xls,.xlsx",
	},
	{ id: "Invoice", name: "osfc.fields.document.types.invoice", accept: ".pdf,.doc,.docx" },
	{ id: "Loading chart", name: "osfc.fields.document.types.loading_chart", accept: ".pdf" },
	{ id: "Off loading chart", name: "osfc.fields.document.types.off_loading_chart", accept: ".pdf" },
	{ id: "Bill og loading", name: "osfc.fields.document.types.bill_og_loading", accept: ".pdf" },
	{ id: "SAD", name: "osfc.fields.document.types.sad", accept: ".pdf" },
	{ id: "T1", name: "osfc.fields.document.types.t1", accept: ".pdf" },
	{ id: "MIO", name: "osfc.fields.document.types.mio", accept: ".pdf" },
	{ id: "Deviation report", name: "osfc.fields.document.types.deviation_report", accept: ".pdf" },
	{ id: "Label", name: "osfc.fields.document.types.label", accept: ".pdf" },
	{ id: "Pictures", name: "osfc.fields.document.types.pictures", accept: ".jpg,.jpeg,.png,.webp" },
	{ id: "Plukk list", name: "osfc.fields.document.types.company_plukk_list", accept: ".pdf" },
	{
		id: "Plukk list scanned",
		name: "osfc.fields.document.types.plukk_list_scanned",
		accept: ".pdf",
	},
	{ id: "3PL/4PL", name: "osfc.fields.document.types.3pl_4pl", accept: ".pdf" },
];
